





























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import FormField from '@/components/form/FormField.vue';
import { ValidationError } from 'class-validator';
import i18next from 'i18next';

interface IResizeImageOptions {
  maxSize: number;
  file: File;
}

@Component({
  components: { FormField },
})
export default class ImageUploadField extends Vue {
  @Prop(String)
  public identifier!: string;

  @Prop({ type: Boolean, default: true })
  public labelIsPath!: boolean;

  @Prop(String)
  public label!: string;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Boolean)
  public isMandatory!: boolean;

  @Prop(Array)
  public options!: Array<{ value: string | number; label: string | number }>;

  @Prop(Object)
  public validationError!: ValidationError | null;

  @Prop(String)
  public value!: string | null;

  public uploadStatus: string = '';

  public get placeholder(): string {
    if (this.value) {
      return (this.uploadStatus = this.translate('booking.annualCardPhoto.uploaded'));
    }
    return (this.uploadStatus = this.translate('form.uploadField.default.label'));
  }

  @Emit()
  public infoClick(): void {}

  public translate(path: string, params?: any): string {
    return i18next.t(path, params);
  }

  public onChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.uploadStatus = this.translate('booking.annualCardPhoto.uploaded');
      if (!this.allowedTypes().includes(target.files[0].type)) {
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: i18next.t('upload.wrongFormat.title'),
            message: i18next.t('upload.wrongFormat.body'),
          },
        });
        this.$emit('input', undefined);
        return;
      }
      const that = this;
      this.resizeImage({
        file: target.files[0],
        maxSize: 1000,
      })
        .then(function(resizedImage) {
          that.$emit('input', resizedImage);
          target.type = 'text';
          target.type = 'file';
        })
        .catch(function(err) {
          console.error(err);
        });
    }
  }

  get allowedTypesAsString() {
    return this.allowedTypes().join(',');
  }

  private allowedTypes(): string[] {
    return ['image/png', 'image/jpeg'];
  }

  private resizeImage(settings: IResizeImageOptions): Promise<string> {
    const file = settings.file;
    const maxSize = settings.maxSize;
    const reader = new FileReader();
    const image = new Image();

    const resize = () => {
      let width = image.width;
      let height = image.height;

      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      //@ts-ignore
      canvas.getContext('2d').drawImage(image, 0, 0, width, height);

      return canvas.toDataURL('image/png');
    };

    return new Promise((ok, no) => {
      if (!file.type.match(/image.*/)) {
        no(new Error('Not an image'));
        return;
      }

      reader.onload = (readerEvent: any) => {
        image.onload = () => ok(resize());
        image.src = readerEvent.target.result;
      };
      reader.readAsDataURL(file);
    });
  }
}
